import React from 'react'
import { HubStyleObject, useToken } from '@hub/design-system-base'
import { Box } from '@hub/box'

interface MainNavItemWrapperProps {
  isDisplayedHorizontally?: boolean
  sx?: HubStyleObject
  onMouseMove?: React.MouseEventHandler
  onMouseEnter?: React.MouseEventHandler
  onMouseLeave?: React.MouseEventHandler
  onFocus?: React.FocusEventHandler
  onBlur?: React.FocusEventHandler
  onKeyDown?: React.KeyboardEventHandler
}

export const MainNavItemWrapper = React.forwardRef<
  HTMLLIElement,
  React.PropsWithChildren<MainNavItemWrapperProps>
>(({ isDisplayedHorizontally = false, sx, ...props }, ref) => {
  const paddingX = useToken('spacing', 'spacing-sm')
  return (
    <Box
      as={props => <li ref={ref} {...props} />}
      {...props}
      sx={{
        whiteSpace: 'nowrap',
        height: 'size-full',
        ...(isDisplayedHorizontally
          ? {
              '& > a, & > button': {
                paddingLeft: 'spacing-sm',
                paddingRight: 'spacing-sm',
              },
              '&:first-of-type > a, &:first-of-type > button': {
                paddingLeft: 0,
              },
              '&:last-of-type > a, &:last-of-type > button': {
                paddingRight: 0,
              },
              _hover: {
                '& > a, & > button': {
                  position: 'relative',
                },
                '& > a:before, & > button:before': {
                  content: '""',
                  position: 'absolute',
                  left: paddingX,
                  right: paddingX,
                  bottom: 0,
                  height: '2px',
                  backgroundColor: 'licorice',
                },
                '&:first-of-type > a:before, &:first-of-type > button:before': {
                  left: '0',
                },
                '&:last-of-type > a:before, &:last-of-type > button:before': {
                  right: '0',
                },
              },
            }
          : {}),
        ...sx,
      }}
    />
  )
})
MainNavItemWrapper.displayName = 'MainNavItemWrapper'
